import React from 'react'
import clsx from 'clsx'
import { TableCell } from '@mui/material'
import { IconName } from 'src/components/atoms'
import CircleWithIcon, { Color } from 'src/components/molecules/CircleWithIcon'
import cellStyles from 'src/components/tables/Cells/styles.module.scss'

export type CircleWithIconCellProps = {
  icon: IconName
  size: number
  color: Color
} & React.StyledProps

export const CircleWithIconCell = React.memo(
  ({ className, style, icon, size, color }: CircleWithIconCellProps) => {
    return (
      <TableCell className={clsx(className, cellStyles.cell)} style={style}>
        <CircleWithIcon icon={icon} size={size} color={color} />
      </TableCell>
    )
  }
)

CircleWithIconCell.displayName = 'CircleWithIconCell'
